import { render, staticRenderFns } from "./SearchBarComponent.vue?vue&type=template&id=f7825780&scoped=true"
import script from "./SearchBarComponent.vue?vue&type=script&lang=js"
export * from "./SearchBarComponent.vue?vue&type=script&lang=js"
import style0 from "./SearchBarComponent.vue?vue&type=style&index=0&id=f7825780&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7825780",
  null
  
)

export default component.exports